import RcCheckbox from "rc-checkbox";
import React from "react";
import classNames from "classnames";
import PureRenderMixin from "react-addons-pure-render-mixin";
import isEmpty from "lodash/isEmpty";

export default class Checkbox extends React.Component {
  static defaultProps = {
    prefixCls: "ant-checkbox"
  };
  shouldComponentUpdate(...args) {
    return PureRenderMixin.shouldComponentUpdate.apply(this, args);
  }
  render() {
    const {
      prefixCls,
      style,
      children,
      className,
      ecId,
      indeterminate,
      ...restProps
    } = this.props;
    const classString = classNames({
      [className]: !!className,
      [`${prefixCls}-wrapper`]: true,
      [`${prefixCls}-indeterminate`]: indeterminate
    });
    return (
      <label
        className={classString}
        style={style}
        ecId={`${ecId}_label@2g0d78`}
      >
        <RcCheckbox {...restProps} prefixCls={prefixCls} children={null} />
        {!isEmpty(children) ? <span>{children}</span> : null}
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/checkbox/checkbox.jsx